import { compact } from 'lodash'

const marketIndexGradients = [
  // [r,g,b]
  [65, 185, 250],
  [252, 90, 166]
]

const marketIndexMinMax = [0, 100]

const rgbColor = color => `rgb(${compact(color).join(', ')})`

const calcColor = (c1, c2, percent) =>
  c1.map((v, i) => Math.round(c1[i] + percent * (c2[i] - c1[i])))

const getColorValueForGradient = (value, [grad1, grad2], [min, max]) => {
  const offset = ((value - min) / (max - min)) * 100

  if (offset <= 25) {
    return rgbColor(grad1)
  }

  if (offset >= 75) {
    return rgbColor(grad2)
  }

  const mixed = calcColor(grad1, grad2, (offset - 25) / 50)

  return rgbColor(mixed)
}

export const getColorForMarketIndex = index =>
  getColorValueForGradient(index, marketIndexGradients, marketIndexMinMax)

export default getColorForMarketIndex
